module.exports = __webpack_public_path__ + "img/support-code.12a1ba1.png";